import React from "react";
import Funds from "../../../components/Funds/Funds";

const FundsPage = () => {
   return <Funds />;
};

export default FundsPage;
